import { KeyValue } from '@/main/models/common';
import { AddressTypes, AddressActionTypes } from './addressTypes';
import { AddressByCompanyBuyerRequest} from '@/main/models/request';

export function getAddress(
  request: AddressByCompanyBuyerRequest,
  keyReducer: string = 'default'
): AddressActionTypes {
  return {
    type: AddressTypes.GET_ADDRESS,
    payload: { request, keyReducer }
  };
}

export function saveAddress(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): AddressActionTypes {
  return {
    type: AddressTypes.SAVE_ADDRESS,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerAddress(): AddressActionTypes {
  return {
    type: AddressTypes.RESET_REDUCER_ADDRESS
  };
}

